import { FC } from 'react';
import { ArrowIcon } from 'assets';
import * as S from './styled';

interface EditingHeaderProps {
  title: string;
  onClick: () => void;
}

const EditingHeader: FC<EditingHeaderProps> = ({ title, onClick }) => {
  return (
    <S.EditingHeader>
      <ArrowIcon onClick={onClick} />
      <S.EditingHeaderTitle>{title}</S.EditingHeaderTitle>
    </S.EditingHeader>
  );
};

export default EditingHeader;
